import styled, { css } from 'styled-components';
import { Currency } from '../../ui/ItemCard/styled';
import { Breakpoints } from '../../../styled/constants';
import { getSafeAreaValue } from '../../../styled/theme/helpers/getSafeAreaValue';
import { FlexCenterAligned } from '../../../styled/common';
import { MapButtonEnum } from './BackToFiltersButton';

export const PriceValue = styled.span`
  display: inline-flex;
  align-items: center;

  ${Currency} {
    margin: 0;
  }

  svg {
    margin: 0;
  }
`;

export const SearchResultMapContainer = styled.div<{
  $markersLoading: boolean;
}>`
  opacity: ${({ $markersLoading }) => ($markersLoading ? 0.9 : 1)};
  transition: opacity 0.2s ease-in-out;
  margin-bottom: ${({ theme }) => getSafeAreaValue(theme, 'bottom', 0, 20)};
  position: relative;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    position: static;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    margin: 0 20px 140px;
  }
`;

const mapPositionStyles = {
  [MapButtonEnum.top]: css`
    position: absolute;
    top: 10px;
    bottom: auto;
  `,
  [MapButtonEnum.fixed]: css`
    position: fixed;
    top: 75px;
    bottom: auto;
  `,
  [MapButtonEnum.bottom]: css`
    position: absolute;
    top: auto;
    bottom: 10px;
  `
};

export const BackToFiltersButtonContainer = styled(FlexCenterAligned)<{
  $position: MapButtonEnum;
}>`
  height: 36px;
  padding: 0 10px;
  gap: 3px;
  background-color: rgba(254, 254, 254, 0.8);
  border-radius: 14px;
  right: 10px;
  z-index: 30;
  ${({ $position }) => mapPositionStyles[$position]};

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;
